import { css } from '@emotion/react';
import { DIMENSIONS } from '@vc-workspace/utils-dimens';
export var containerStyles = /*#__PURE__*/css({
  display: 'inline-grid',
  gridGap: '52px',
  gap: '52px',
  gridTemplateColumns: 'repeat(6, 1fr)',
  '& > a': {
    display: 'inline-block'
  },
  '@media screen and (min-width: 768px) and (max-width: 1500px)': {
    gridTemplateColumns: 'repeat(5, 1fr)'
  },
  '@media screen and (max-width: 768px)': {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    columnGap: '0px',
    rowGap: '0px',
    '& > a': {
      display: 'block',
      marginRight: '8px',
      marginBottom: DIMENSIONS.px_52
    },
    '& > a:nth-of-type(2n)': {
      marginLeft: '8px',
      marginRight: '0px',
      marginBottom: DIMENSIONS.px_52
    }
  }
}, true ? "" : ";label:containerStyles;", true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi91c3Ivc3JjL2FwcC9hcHBzL21hcmtldHBsYWNlL2NvbXBvbmVudHMvcHJvZHVjdC1zdGFjay1saXN0L3Byb2R1Y3Qtc3RhY2stbGlzdC5tb2R1bGUuc3R5bGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUcrQiIsImZpbGUiOiIvdXNyL3NyYy9hcHAvYXBwcy9tYXJrZXRwbGFjZS9jb21wb25lbnRzL3Byb2R1Y3Qtc3RhY2stbGlzdC9wcm9kdWN0LXN0YWNrLWxpc3QubW9kdWxlLnN0eWxlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IERJTUVOU0lPTlMgfSBmcm9tICdAdmMtd29ya3NwYWNlL3V0aWxzLWRpbWVucyc7XG5cbmV4cG9ydCBjb25zdCBjb250YWluZXJTdHlsZXMgPSBjc3Moe1xuICBkaXNwbGF5OiAnaW5saW5lLWdyaWQnLFxuICBncmlkR2FwOiAnNTJweCcsIFxuICBnYXA6ICc1MnB4JyxcbiAgZ3JpZFRlbXBsYXRlQ29sdW1uczogJ3JlcGVhdCg2LCAxZnIpJyxcbiAgJyYgPiBhJzoge1xuICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snXG4gIH0sXG4gICdAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgYW5kIChtYXgtd2lkdGg6IDE1MDBweCknOiB7XG4gICAgZ3JpZFRlbXBsYXRlQ29sdW1uczogJ3JlcGVhdCg1LCAxZnIpJyxcbiAgfSxcbiAgJ0BtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDc2OHB4KSc6IHtcbiAgICBkaXNwbGF5OiAnZmxleCcsXG4gICAgZmxleEZsb3c6ICdyb3cgd3JhcCcsXG4gICAganVzdGlmeUNvbnRlbnQ6ICdzcGFjZS1iZXR3ZWVuJyxcbiAgICBjb2x1bW5HYXA6ICcwcHgnLFxuICAgIHJvd0dhcDogJzBweCcsXG4gICAgJyYgPiBhJzoge1xuICAgICAgZGlzcGxheTogJ2Jsb2NrJyxcbiAgICAgIG1hcmdpblJpZ2h0OiAnOHB4JyxcbiAgICAgIG1hcmdpbkJvdHRvbTogRElNRU5TSU9OUy5weF81MixcbiAgICB9LFxuICAgICcmID4gYTpudGgtb2YtdHlwZSgybiknOiB7XG4gICAgICBtYXJnaW5MZWZ0OiAnOHB4JyxcbiAgICAgIG1hcmdpblJpZ2h0OiAnMHB4JyxcbiAgICAgIG1hcmdpbkJvdHRvbTogRElNRU5TSU9OUy5weF81MixcbiAgICB9LFxuICB9LFxufSk7XG4iXX0= */");